import { render, staticRenderFns } from "./PrivateChannel.vue?vue&type=template&id=f7669b82&"
import script from "./PrivateChannel.vue?vue&type=script&lang=js&"
export * from "./PrivateChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports